import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import "./navbar.scss";
import { useNavigate } from 'react-router-dom';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// import { DarkModeContext } from "../../context/darkModeContext";
// import { useContext } from "react";

const Navbar = () => {
  const tenantDetails = JSON.parse(sessionStorage.getItem("tenantDetails"))
  const navigate = useNavigate();
  const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))

  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const signout = () => {
    navigate("/")
    sessionStorage.clear(); 
  }
  const handleMyprofileRoute = () => {
    navigate("/my-profile")

  }
  
  return (
    <div className="navbar">
      <div className="wrapper">
        <div className="search">
          <span class="navbar-text mr-2 font-weight-bold h5">
            {tenantDetails && tenantDetails !== null && tenantDetails?.length > 0 ? tenantDetails?.reduce((a) => a)?.tenantName : ""}
          </span>
        </div>
        <div className="items">

          <div className="user-info">
            <FiberManualRecordIcon className="activ-icon" />{getUserValue?.userName}
          </div>
          {/* <div className="item">
            <DarkModeOutlinedIcon
              className="icon"
              onClick={() => dispatch({ type: "TOGGLE" })}
            />
          </div> */}
          <div className="item">
            {auth && (
              <div>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  className="pop-over-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                > <MenuItem onClick={handleMyprofileRoute}>My Profile</MenuItem>
                  {/* <MenuItem onClick={handleClose}>Change Password</MenuItem> */}
                  <MenuItem onClick={signout}>Signout</MenuItem>
                </Menu>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
